import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, TextField, Button, Typography, Alert, Link, Divider } from "@mui/material";
import { useAuth } from "./AuthContext";

export default function Login() {
  const { login, loginWithMicrosoft, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  const msLogin = async () => {
    setError(null); setBusy(true);
    try {
      await loginWithMicrosoft();
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err?.message || "Microsoft sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", bgcolor: "background.default" }}>
      <Paper component="form" onSubmit={submit} sx={{ p: 4, width: 360, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>Swan Admin</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Button type="submit" variant="contained" disabled={busy}>{busy ? "Signing in…" : "Sign In"}</Button>
        <Typography variant="caption" sx={{ textAlign: "center", color: "text.secondary" }}>or</Typography>
        <Button variant="outlined" disabled={busy} onClick={msLogin}>Sign in with Microsoft</Button>
        {user && (
          <>
            <Divider sx={{ my: 0.5 }} />
            <Link
              component="button"
              type="button"
              onClick={() => navigate("/admin")}
              sx={{ textAlign: "center", fontWeight: 600 }}
            >
              Go to Dashboard →
            </Link>
          </>
        )}
      </Paper>
    </Box>
  );
}
